import { useState } from 'react';
import useWindowSize from 'react-use/lib/useWindowSize';
import Confetti from 'react-confetti';
/////////////////////////////////////////////////////////
import { Product } from '@/app/shared/components';
import { useCustomSelector } from '@/core/redux/hooks';

export const ProductsList: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/
	const { width, height } = useWindowSize();

	/*********************
	// #region Redux
	**********************/
	const { products } = useCustomSelector((state) => state.shop);

	/*********************
	// #region States
	**********************/
	const [showConfetti, setShowConfetti] = useState(false);

	/*********************
	// #region Template
	**********************/
	return (
		<>
			<div className="grid grid-cols-2 gap-4">
				{products.map((item, index) => (
					<Product
						product={item}
						key={index}
						showConfetti={() => setShowConfetti(true)}
					/>
				))}
			</div>
			{showConfetti && (
				<Confetti
					width={width}
					height={height}
					className="z-200 !fixed top-0 left-0"
				/>
			)}
		</>
	);
};
